import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import './createcategory.css'
import AdminNavbar from '../../admin-components/admin-nav/AdminNavbar'
import AdminBottomNav from '../../admin-components/adminbottomnav/AdminBottomNav'
import axios from 'axios';

function CreateCategory() {
    const [name, setName] = useState({});

    const api_uri = "https://mentorxfa.herokuapp.com/api";
    const history = useHistory();

    const handleSubmit = async (e)=>{
        e.preventDefault();        
        
        const newCat = {
            name
        }
        try {         
            const res = await axios.post(api_uri+"/categories", newCat);  
            setTimeout(() => {     
                history.push("/admin/categories/"+res.data._id)
            }, 200)               
        } catch (err) {
            console.log(err);            
        }
    }

    return (
        <>
        <AdminNavbar/>
        <div className="create-category">
            <h2 className="category-title">Create Category</h2>  
            <form action="#" className="category-form" onSubmit={handleSubmit} >                                                       
                <input type="text" required onChange={e => setName(e.target.value)}  className="category-input" placeholder="Name" />
                    {/* <Switch onChange={() => setChecked(!checked)} />        */}
                <button className="category-submit-btn">Create</button>      
            </form>  
        </div>
        <AdminBottomNav/>
        </>
    )
}

export default CreateCategory
